/*
 * @Author: CAIJUN 1509317743@qq.com
 * @Date: 2026-03-17 11:20:44
 * @LastEditors: CAIJUN 1509317743@qq.com
 * @LastEditTime: 2026-09-27 14:53:43
 * @FilePath: \luckysheet-source-private-master\src\controllers\fileProcess.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// API 配置
// 正式环境
 const API_BASE_URL = 'https://smriqc.hitur.com';
//const API_BASE_URL = 'http://localhost:54185';

function getApiUrl(endpoint) {
    return `${API_BASE_URL}${endpoint}`;
}

// 根据类别自动导入Excel文件

export { getApiUrl };
